export const MOBILE_BREAK_POINT = 1024;
export const SLIDER_PANEL_MAX_WIDTH = "1250px";
export const SLIDER_PANEL_WIDTH = "80vw";
export const $FONT_COLOR_DARK = "#374968";
export const OG_IMG_LINK = "https://rayark.promo/deemo2_og.jpg";
